import axios from "axios";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Custom log function
import { auth, dbCentral } from "../../config/FirebaseConfig";
import { extractExtension, extractName } from "../helpers/formatHelpers";

const uploadFiles = async (dropped_files, id, key, token, prefix) => {
  try {
    let fresh_files = [];
    let data;
    for (const up of dropped_files) {
      const fileUrl = up.url;

      // Download the file from the provided URL using Axios
      const fileResponse = await axios.get(fileUrl, {
        responseType: "arraybuffer",
      });

      if (fileResponse.status === 200) {
        // Convert the response to Uint8Array to ensure binary data integrity
        const fileBytes = new Uint8Array(fileResponse.data);
        const datestring = // DDHHMMSS
          new Date().toISOString().replace(/[-:.]/g, "").slice(0, 8);
        // Generate a unique file name using the original name and current date

        let extract_name = extractName(up.name);
        let extract_ext = extractExtension(up.name);
        console.log("extract_name", extract_name);
        console.log("extract_ext", extract_ext);
        let fileName =
          extractName(up.name) +
          "_" +
          datestring +
          "." +
          extractExtension(up.name);
        fileName = fileName.replace(/ /g, "_");

        const url = `${prefix}upload/file`;

        // Prepare the FormData with explicit MIME type for PDF
        const formData = new FormData();
        formData.append(
          "file",
          new Blob([fileBytes], { type: "application/pdf" }),
          fileName
        );
        let specific_id = id + fileName;
        formData.append("id", specific_id); // Append the ID to the FormData
        formData.append("key", key || ""); // Append the key to the FormData

        // Define headers, letting Axios handle the multipart Content-Type
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        let start = new Date();

        // Upload the file using Axios
        const response = await axios.post(url, formData, { headers });
        // i want JSON response
        const responseText = await response.data;
        const file = responseText.file;
        data = responseText.data;
        fresh_files.push(file);
        // Firebase authentication to get current user
        const currentUser = auth.currentUser;

        if (!currentUser) {
          console.error("User is not authenticated");
          return;
        }

        if (response.status === 200) {
          return { files: fresh_files, data: data };
        } else {
          console.error(
            `Error response for file ${fileName}: ${response.status}`
          );
        }

        // Access Firestore to retrieve the user document
        const userRef = doc(dbCentral, "user", currentUser.uid);
        const userSnapshot = await getDoc(userRef);

        if (!userSnapshot.exists()) {
          console.error("User document not found");
          return;
        }
        const org_id = userSnapshot.get("org_id");

        let end = new Date();
        let elapsed = end - start;
        // Log the document upload
        await addLogDocument(
          url,
          prefix,
          userRef,
          org_id,
          response.status.toString(),
          "",
          "", // Assuming empty for additional data
          "", // Assuming no specific request body
          responseText,
          "POST",
          elapsed
        );
      } else {
        console.error(
          `Failed to download file from URL: ${fileResponse.status}`
        );
      }
    }
  } catch (error) {
    console.error("Error processing files:", error);
  }
};

export default uploadFiles;
